/**
 * Utility functions for authentication and authorization
 */

/**
 * Parses a JWT token and extracts the payload
 * @param token - The JWT token to parse
 * @returns The parsed payload or null if parsing fails
 */
export function parseJwtPayload(token: string): any | null {
  try {
    const parts = token.split('.')
    if (parts.length !== 3) {
      return null
    }

    const payload = JSON.parse(
      atob(parts[1].replace(/-/g, '+').replace(/_/g, '/')),
    )
    return payload
  } catch (error) {
    console.error('Error parsing JWT token:', error)
    return null
  }
}

/**
 * Checks if a user has super admin role based on their JWT token
 * @param accessToken - The user's access token
 * @returns True if the user is a super admin, false otherwise
 */
export function isSuperAdmin(accessToken: string): boolean {
  const payload = parseJwtPayload(accessToken)
  if (!payload) {
    return false
  }

  return payload.role === 'org-super-data-administrator'
}

/**
 * Super admin selected company ID storage key
 */
export const SUPER_ADMIN_COMPANY_KEY = 'superAdminSelectedCompanyId'
